import { Loader } from '@googlemaps/js-api-loader';

const element = document.querySelector('.js-map');

const loader = new Loader({
  apiKey: wordpress.googleApiKey,
  version: 'weekly',
  libraries: ['places'],
});

if (element) {
  loader.loadCallback(() => handleLoad());
}

function handleLoad() {
  //

  const position = {
    lat: Number(element.getAttribute('data-lat')),
    lng: Number(element.getAttribute('data-lng')),
  };

  const map = new google.maps.Map(element, {
    center: position,
    clickableIcons: false,
    zoom: 15,
  });

  const icon = {
    url: element.getAttribute('data-marker'),
    anchor: new google.maps.Point(28, 83),
    scaledSize: new google.maps.Size(56, 83),
  };

  const marker = new google.maps.Marker({ position, map, icon });
}
